<template>
    <div class="row">
      <LoaderMaskComponent v-if="lyLoading" />
      <div v-else>
        <div class="no_left_content">
          <h5 class="common_subtitle pb_20 border-lightgray-bottom mb_20">Add disk </h5>
          <div class="vm_checkout_content">
            <div class="vm_checkout_left">
              <div class="mb-3">
                <label for="name" class="col-form-label">Disk Name</label>
                <input type="text" class="form-control" id="name" v-model="form.name">
                <v-errors :errors="errorFor('name')"></v-errors>
              </div>
              <div class="mb-3">
                <label for="disk_product_type" class="col-form-label">Disk product</label>
                <select class="form-select" v-model="form.disk_product_type" id="disk_product_type" @change="changeDiskProductType()">
                  <option value="HDD">HDD</option>
                </select>
                <v-errors :errors="errorFor('disk_product_type')"></v-errors>
              </div>
              <div class="row">
                <div class="col_12" v-if="form.disk_product_type === 'HDD'">
                  <div class="mb-3">
                    <label for="disk_offering_id" class="col-form-label">Volume</label>
                    <select class="form-select" id="disk_offering_id" v-model="form.disk_offering_id" @change="changeDiskVolume()">
                      <option  v-for="(diskOffering, index) in diskOfferings" :key="'disk_offering_'+index" :value="diskOffering.id">
                        {{ diskOffering.size }} GB
                      </option>
                    </select>
                    <v-errors :errors="errorFor('disk_offering_id')"></v-errors>
                  </div>
                </div>
                <template v-else>
                  <div class="col_6">
                    <div class="mb-3">
                      <label for="disk_offering_id" class="col-form-label">Volume</label>
                      <select class="form-select" id="disk_offering_id" v-model="form.disk_offering_id" @change="fetchIops()">
                        <option  v-for="(diskOffering, index) in diskOfferings" :key="'disk_offering_'+index" :value="diskOffering.id">
                          {{ diskOffering.size }} GB
                        </option>
                      </select>
                      <v-errors :errors="errorFor('disk_offering_id')"></v-errors>
                    </div>
                  </div>
                </template>
              </div>
              <div class="mb-3">
                <label for="billing_type" class="col-form-label">Billing type</label>
                <select class="form-select" v-model="form.billing_type" id="billing_type">
                  <option value="monthly">Monthly</option>
                  <option value="hourly">Hourly</option>
                </select>
                <v-errors :errors="errorFor('billing_type')"></v-errors>
              </div>
            </div>
            <div class="vm_checkout_right">
              <div class="vm_checkout_right_wrap">
                <h5 class="common_subtitle">Estimated Bill</h5>
                <div class="checkout_right_inner">
                  <div class="d_flex_btwn inner_title">
                    <span>Disk details</span>
                    <span v-if="form.billing_type === 'monthly'">￦{{ selectedDiskOffering?.monthly_price }}</span>
                    <span v-else>￦{{ selectedDiskOffering?.hourly_price }}</span>
                  </div>
                  <div class="vm_checkout_table">
                    <table class="table">
                      <tbody>
                      <tr>
                        <td>Disk volume</td>
                        <td>{{ selectedDiskOffering?.size }} GB</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="checkout_subtotal">
                    <template v-if="form.billing_type === 'monthly'">
                      <p class="mb_5">Total estimated bill(1 month)</p>
                      <h2 class="subtotal">￦{{selectedDiskOffering?.monthly_price }}</h2>
                    </template>
                    <template v-else>
                      <p class="mb_5">Total estimated bill(1 hour)</p>
                      <h2 class="subtotal">￦{{ selectedDiskOffering?.hourly_price }}</h2>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d_flex_end custom_border_top mt_20 pt_20 pb_20">
          <button type="button" class="btn btn-outline-danger mr_5" @click.prevent="cancelOperation()">Cancel</button>
          <button type="button" class="btn btn-primary btn-md  width_100p" :disabled="lyLoading" @click.prevent="submitDplatform">Launch</button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
    import {mapGetters} from "vuex";
      import LoaderMaskComponent from "@/components/LoaderMaskComponent.vue";
      export default {
          name: 'VlanCloudDiskForm',
          components: {LoaderMaskComponent},
          data(){
              return {
                lyLoading: false,
                form: {
                  name: '',
                  disk_product_type: 'HDD',
                  billing_type: 'hourly',
                  disk_offering_id: '',
                },
                diskOfferings: [],
                selectedDiskOffering: null,
                selectedDiskOfferingIops: null,
                errorMessages: '',
              }
          },
          computed:{
                ...mapGetters({
                    customer: 'auth/getUserInfo',
                }),
            },
          mounted() {
              this.fetchDiskOfferings()
          },
          methods: {
            changeDiskProductType(){
                this.fetchDiskOfferings()
            },
            fetchDiskOfferings(){
                let formData = {
                    disk_product_type: this.form.disk_product_type,
                };
                this.axios.post('/get-vlan-cloud-disk-offerings', formData)
                .then(({data}) => {
                    this.diskOfferings = data
                    if(this.diskOfferings.length > 0){
                        this.selectedDiskOffering =  this.diskOfferings[0]
                        this.form.disk_offering_id = this.selectedDiskOffering.id
                    }else{
                        this.selectedDiskOffering = null
                        this.form.disk_offering_id = ''
                    }
                })
            },
            validateSpace() {
                if (this.form.space % 10 !== 0) {
                    this.errorMessages = "Capacity must be in increments of 10 GB.";
                } else {
                    this.errorMessages = null;
                }
            },
            changeDiskVolume(){
                let result = this.diskOfferings.filter(e => e.id == this.form.disk_offering_id)
                this.selectedDiskOffering = result[0]
            },
            cancelOperation(){
                this.$swal({
                    title: 'Are you sure want to cancel?',
                    text: "It will stop disk creation!",
                    showCancelButton: true,
                    confirmButtonText: 'Yes, cancel it!',
                    confirmButtonColor: '#dd4b39',
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.$router.push('cloud-disks');
                    }
                });
            },
            submit() {
              this.allErrors = null;
              this.lyLoading = true;
              
              this.axios.post('/cloud-disks', this.form)
              .then((response) => {
                if(response.data.success){
                    this.showSuccessMsg(response.data.message);
                    this.$router.push('cloud-disks');
                }else{
                    this.$swal({
                        text: response.data.message,
                        showCancelButton: false,
                        confirmButtonText: 'Close!',
                        confirmButtonColor: '#dd4b39',
                        reverseButtons: true
                    })
                }
              })
              .catch((err) => {
                  this.allErrors = err.response.data.errors
                  this.showFailMsg(err.response.data.message);
              })
              .finally(() => {
                  this.lyLoading = false;
              })
            },
            submitDplatform() {
              this.allErrors = null;
              this.lyLoading = true;
              
              this.axios.post('/proxmox/create-storage', this.form)
              .then((response) => {
                if(response.data.success){
                    this.showSuccessMsg(response.data.message);
                    this.$router.push('cloud-disks');
                }else{
                    this.$swal({
                        text: response.data.message,
                        showCancelButton: false,
                        confirmButtonText: 'Close!',
                        confirmButtonColor: '#dd4b39',
                        reverseButtons: true
                    })
                }
              })
              .catch((err) => {
                this.errorMessages = ''
                this.allErrors = err.response.data.errors
                this.showFailMsg(err.response.data.message);
              })
              .finally(() => {
                this.lyLoading = false;
              })
            },
        }
      }
  </script>
  <style scoped>

  </style>
  